export default "__VITE_ASSET__94Ne0tRr__"